const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArcadeButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.839 0.362 22.634 22.344",
    width: 22.634,
    height: 22.344,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "var(--theme-secondary)"
    },
    cx: 12.156,
    cy: 11.534,
    rx: 11.317,
    ry: 11.172
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "rgb(46, 46, 46)"
    },
    cx: 11.44,
    cy: 12.465,
    rx: 7.736,
    ry: 7.735
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      stroke: "rgb(0, 0, 0)",
      strokeWidth: 0,
      fill: "var(--theme-secondary)"
    },
    cx: 11.941,
    cy: 11.464,
    rx: 7.806,
    ry: 7.664
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArcadeButton);
export default __webpack_public_path__ + "static/media/arcadeButton.cb62fe6add623c50f8901a6f88265f5c.svg";
export { ForwardRef as ReactComponent };